import { en } from './en';
import { zh_CHS } from './zh-chs';
import { zh_CHT } from './zh-cht';

export const translate = {
    'zh-CHS': zh_CHS,
    'en': en,
    'zh-CHT': zh_CHT
};